module.exports = __webpack_public_path__ + "img/epic.044ec0d3.png";